import React from 'react';
import PropTypes from 'prop-types';
import { deleteAccessPointAccessMethod } from 'store/actions/accessPoints/access-methods/delete/deleteAccessPointAccessMethod';
import accessMethodsHelper from 'helpers/accessMethodsHelper';
import DeleteAction from 'components/field/DropDownActionsMenu/DeleteAction';
import DropDownActionsMenu from 'components/field/DropDownActionsMenu/DropDownActionsMenu';
import EditAction from 'components/field/DropDownActionsMenu/EditAction';
import FieldTitle from 'components/aor/FieldTitle';
import HeaderColumn from 'components/ui/table/HeaderColumn';
import OpenGateAction from 'pages/accessPoints/access-methods/OpenGateAction';
import Table from 'components/ui/table/Table';
import TableBodyCell from 'components/table/TableBodyCell';
import TableRow from 'components/ui/table/TableRow';
import TextField from 'components/show/TextField';
import translate from 'components/hoc/translate';
import utils from 'helpers/utils';

const AccessMethodsList = (props) => {
    const {
        createAccessMethodOpen,
        data,
        resource,
        translate,
    } = props;

    return (
        <Table responsive='scroll'>
            <TableRow>
                <HeaderColumn style={ { width: '30%' } }>
                    <FieldTitle
                        label={ translate('resources.access_methods.fields.name') }
                        source='access_method_id'
                        resource='productAccessMethods'
                    />
                </HeaderColumn>
                <HeaderColumn style={ { width: '20%' } }>
                    <FieldTitle
                        label={ translate('resources.access_methods.list.direction') }
                        source='access_direction'
                        resource='productAccessMethods'
                    />
                </HeaderColumn>
                <HeaderColumn style={ { width: '20%' } }>
                    <FieldTitle
                        label={ translate('resources.access_methods.list.enabled') }
                        source='enabled'
                        resource='productAccessMethods'
                    />
                </HeaderColumn>
                <HeaderColumn style={ { width: '20%' } }>
                    <FieldTitle
                        label={ translate('resources.access_methods.fields.is_allowed_for_users') }
                        source='is_allowed_for_users'
                        resource='productAccessMethods'
                    />
                </HeaderColumn>
                <HeaderColumn style={ { width: '10%' } }>&nbsp;</HeaderColumn>
            </TableRow>

            {
                utils.map(data, (method) => {
                    const {
                        access_method_id,
                        access_direction,
                        enabled,
                        id,
                        is_allowed_for_users = false,
                    } = method;

                    return (
                        <TableRow
                            key={ `${ method }-${ id }` }
                        >
                            <TableBodyCell
                                field={ <TextField value={ accessMethodsHelper.getMethodName(access_method_id) } /> }
                                record={ method }
                                source='access_method_id'
                            />

                            <TableBodyCell
                                field={ <TextField value={ translate(`resources.access_methods.list.directions.${ access_direction }`) } /> }
                                record={ method }
                                source='access_direction'
                            />

                            <TableBodyCell
                                field={ <TextField value={ translate(`resources.access_methods.list.${ enabled ? 'active' : 'inactive' }`) } /> }
                                record={ method }
                                source='enabled'
                            />

                            <TableBodyCell
                                field={ <TextField value={ translate(`resources.access_methods.list.${ is_allowed_for_users ? 'active' : 'inactive' }`) } /> }
                                record={ method }
                                source='is_allowed_for_users'
                            />

                            <TableBodyCell
                                field={
                                    <DropDownActionsMenu
                                        record={ method }
                                        resource='access-methods'
                                    >
                                        <OpenGateAction
                                            id={ id }
                                            enabled={ enabled }
                                            label={ translate('resources.access_methods.open') }
                                            title={ translate('resources.access_methods.open') }
                                            action={ createAccessMethodOpen }
                                        />

                                        <EditAction
                                            resource={ resource }
                                            url={ `${ window.location.pathname.replace('show', '') }access-method/${ id }` }
                                        />

                                        <DeleteAction
                                            action={ deleteAccessPointAccessMethod }
                                            description='resources.access_methods.delete.description'
                                            title='resources.access_methods.delete.title'
                                        />
                                    </DropDownActionsMenu>
                                }
                                record={ method }
                                resource={ resource }
                            />
                        </TableRow>
                    );
                })
            }
        </Table>
    );
};

AccessMethodsList.propTypes = {
    createAccessMethodOpen: PropTypes.func.isRequired,
    data: PropTypes.object,
    resource: PropTypes.string.isRequired,
    translate: PropTypes.func,
};

export default translate(AccessMethodsList);


// WEBPACK FOOTER //
// ./src/pages/accessPoints/access-methods/list/AccessMethodsList.js